import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sale-homepage',
  templateUrl: './sale-homepage.component.html',
  styleUrls: ['./sale-homepage.component.css']
})
export class SaleHomepageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
